module.exports = __webpack_public_path__ + "media/images/bnr-chrome-3017f4f301efa4ba71e7dcab2f715cfa.svg";